enum COLORS {
  DEFAULT = '#fff',
  GRAY_0 = '#f4f8ff',
  LIGHTGREEN = '#9BCD41',
  DARKGREEN = '#AADC14',
  LIGHTGREENCLEAR = 'rgba(155, 205, 65, 0.2)',
  GREENCLEAR = '#E6F5BF',
  BLUE = '#D6EAFE',
  BLUE_LIGHT = '#bbdcfd',
  BLUECLEAR = 'rgba(23, 91, 167, 0.2)',
  BLUE_SKY_LIGHT = '#77b7fc',
  BLUESKY = '#35a2eb80',
  DARKBLUE = '#030F40',
}

export default COLORS
